import { notificationTypes } from "content/Notification";
import { toast } from "react-toastify";
import { BellIcon } from "assets/svg";

function NotificationToast(data, theme) {
  toast(<Toast />, {
    position: "bottom-right",
    autoClose: 2500,
    className: "last:!mb-16",
    data,
    theme: theme || "colored",
  });
}

export default NotificationToast;

function Toast({ data }) {
  return (
    <div
      className={`flex items-start p-2 gap-4 rounded-md w-full max-w-[400px]`}
    >
      <div className="size-10 flex items-center justify-start">
        {notificationTypes[data.notificationType] || (
          <BellIcon className="size-8" />
        )}{" "}
      </div>

      <div>
        <h2 className="font-semibold">{data.title}</h2>
        <p>{data.message}</p>
      </div>
    </div>
  );
}
